export default __webpack_public_path__ + "static/media/Group1199.2feb4093.svg";